import Store from '@/store/index.js';

export default {
  methods : {
    routeWithTenant({ name, path, params = {}, query = {} }) {

      return {
        name   : name || '',
        path   : path || '',
        params : {
          ...params,
          tenant : Store.getters.tenant.id
        },
        query
      };
    }
  }
};
